export default "__VITE_ASSET__BzDPlhhK__"